class BsPlayer {
	static #$CHANNEL_LINKS: NodeListOf<HTMLAnchorElement> =
		document.querySelectorAll('.bs-player__menu_link')
	static #$CHANNEL_BROADCASTS: NodeListOf<HTMLDivElement> =
		document.querySelectorAll('.bs-player__video_item')

	static #LINK_ACTIVE_CLASS = 'bs-player__menu_link_active'
	static #BROADCAST_ACTIVE_CLASS = 'bs-player__video_item__active'
	static #BUTTON_INCLUDES = '#bs-player__channel_'

	#channelLinksArray: HTMLAnchorElement[] = null
	#channelBroadcastsArray: HTMLDivElement[] = null

	#addChannelButtonsListeners = () => {
		if (BsPlayer.#$CHANNEL_LINKS.length) {
			if (!this.#channelLinksArray) {
				this.#channelLinksArray = Array.from(BsPlayer.#$CHANNEL_LINKS)
			}

			this.#channelLinksArray.forEach(button => {
				button.addEventListener('click', e => {
					e.preventDefault()
					this.#handleChannelButtonClick(button)
				})
			})
		}
	}

	#handleChannelButtonClick = (link: HTMLAnchorElement) => {
		const linkHash = link.hash

		if (linkHash.includes(BsPlayer.#BUTTON_INCLUDES)) {
			const broadcastId = linkHash.replace('#', '')

			if (BsPlayer.#$CHANNEL_BROADCASTS.length) {
				if (!this.#channelBroadcastsArray) {
					this.#channelBroadcastsArray = Array.from(
						BsPlayer.#$CHANNEL_BROADCASTS
					)
				}

				const broadcast = this.#channelBroadcastsArray.find(
					broadcast => broadcast.id === broadcastId
				)

				if (broadcast) {
					if (!broadcast.classList.contains(BsPlayer.#BROADCAST_ACTIVE_CLASS)) {
						const otherBroadcasts = this.#channelBroadcastsArray.filter(
							broadcast => broadcast.id !== broadcastId
						)

						const otherLinks = this.#channelLinksArray.filter(
							link => link.hash !== linkHash
						)

						if (otherLinks) {
							otherLinks.forEach(link => {
								if (link.classList.contains(BsPlayer.#LINK_ACTIVE_CLASS)) {
									link.classList.remove(BsPlayer.#LINK_ACTIVE_CLASS)
								}
							})
						}

						if (otherBroadcasts) {
							otherBroadcasts.forEach(broadcast => {
								if (
									broadcast.classList.contains(BsPlayer.#BROADCAST_ACTIVE_CLASS)
								) {
									broadcast.classList.remove(BsPlayer.#BROADCAST_ACTIVE_CLASS)
								}
							})
						}

						link.classList.add(BsPlayer.#LINK_ACTIVE_CLASS)
						broadcast.classList.add(BsPlayer.#BROADCAST_ACTIVE_CLASS)
					}
				}
			}
		}
	}

	public init = () => {
		this.#addChannelButtonsListeners()
	}
}

const bsPlayer = new BsPlayer()
bsPlayer.init()
